import * as aor from "react-admin";
import React from "react";
import { POLICY_ROLE_MAPPINGS } from "../../common/rolesManagement";
import MyChipField from "../../components/MyChipField";
import RestrictedEditButton from "../../components/RestrictedEditButton";

const Filter = props => (
    <aor.Filter {...props}>
        <aor.TextInput
            label="resources.role-mappings.filters.username"
            source="username"
            alwaysOn={true}
        />
        <aor.TextInput
            label="resources.role-mappings.filters.company"
            source="company"
            alwaysOn={true}
        />
        <aor.TextInput
            label="resources.role-mappings.filters.role"
            source="description"
            alwaysOn={true}
        />
    </aor.Filter>
);
const RolesAction = props => <aor.CardActions />;

const RenderModifyButton = ({ basePath, record, _ }) => {
    return <RestrictedEditButton basePath={basePath} record={record} />;
};

export default ({ permissions, ...props }) => (
    <aor.List
        {...props}
        title="resources.role-mappings.views.list.title"
        bulkActionButtons={false}
        filters={<Filter />}
        sort={{ field: "user_id", order: "ASC" }}
        actions={<RolesAction />}
    >
        <aor.Datagrid>
            <aor.ReferenceField
                source="user_id"
                reference="users"
                linkType="show"
            >
                <aor.TextField source="username" />
            </aor.ReferenceField>
            <aor.ReferenceField
                source="company_id"
                reference="companies"
                linkType="show"
            >
                <MyChipField source="name" {...props} />
            </aor.ReferenceField>
            <aor.ReferenceField
                source="role_id"
                reference="roles"
                linkType={false}
            >
                <aor.TextField source="description" />
            </aor.ReferenceField>
            {permissions &&
                permissions.includes(POLICY_ROLE_MAPPINGS.UPDATE) && (
                    <RenderModifyButton />
                )}
        </aor.Datagrid>
    </aor.List>
);



// WEBPACK FOOTER //
// ./src/resources/RoleMappings/List.js